import { MDBBtn, MDBDatatable, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalHeader, MDBModalTitle, MDBTypography } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { downloadContacts, getMisc, getWSContactsRedirectHtml } from '../../../apiclients/streamsapi_bridge';
import { getStreamsProductName } from '../../../apiclients/CommonUtils';
import TabIDConstant from '../../../apiclients/TabIDConstant';

function ImportGlobalContacts({ isActive }) {
    const { t, i18n } = useTranslation();
    const [basicModal, setBasicModal] = useState(false);
    const toggleOpen2 = () => setBasicModal(!basicModal);
    const [centredModal2, setCentredModal2] = useState(false);
    const toggleOpen3 = () => setCentredModal2(!centredModal2);
    const previewRef = useRef(null);
    const navigate = useNavigate();
    const streamsProductName = getStreamsProductName();
    // const [expUrl, setexpUrl] = useState("");

    const handleDragOver = (event) => {
        event.preventDefault();
        document
            .getElementById("uploadFile")
            .parentNode.classList.add("draging", "dragBox");
    };

    const handleDrop = (event) => {
        event.preventDefault();
        document
            .getElementById("uploadFile")
            .parentNode.classList.remove("draging");
        document.getElementById("uploadFile").parentNode.classList.add("dragBox");
        const file = event.dataTransfer.files[0];
        previewImage(file);
    };

    const previewImage = (file) => {
        const previewDiv = previewRef.current;

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const previewImage = document.createElement("img");
                previewImage.src = reader.result;
                previewDiv.innerHTML = "";
                previewDiv.appendChild(previewImage);
            };
            reader.readAsDataURL(file);
        } else {
            previewDiv.innerHTML = "";
        }
    };

    const actionData4 = {
        columns: [
            { label: 'Name', field: 'name', sort: true },
            { label: 'Type', field: 'type' },
            { label: 'Action', field: 'action', sort: false },
        ],
        rows: [
            {
                name: 'Designation',
                type: 'Text',
            },
        ].map((row) => {
            return {
                ...row,
                action: (
                    <>
                        <div className="d-flex align-items-center ms-2">
                            <div className="custom-hover-bg p-1 cursor-pointer editToolTip">
                                <MDBIcon fas icon="edit" color="primary" className="mx-2 my-1 fs-5" />
                            </div>
                            <div className="custom-hover-bg p-1 ms-2 cursor-pointer deleteToolTip">
                                <MDBIcon fas icon="times" color="primary" className="mx-2 my-1 fs-5" />
                            </div>
                        </div>
                    </>
                ),
            };
        }),
    };

    // useEffect(() => {
    //     if (isActive) {
    //         getExportUrl();

    //     }

    // }, [isActive]);

    // async function getExportUrl() {

    //     let updates = {};
    //     console.log(sessionStorage.getItem("admin_session"));
    //     updates = {
    //         misc: ["import_global_contacts"],
    //     };

    //     const response = await getMisc(
    //         JSON.parse(sessionStorage.getItem("admin_session")).siteid,
    //         updates
    //     );
    //     if (!response.json) {
    //         const message = `An error has occured: ${response.statusText}`;
    //         return;
    //     }
    //     const basicInfo = await response.json();
    //     if (!basicInfo) {
    //         window.alert(`info with id  not found`);
    //         navigate("/");
    //     }
    //     console.log(
    //         "response data for getExportUrl is :::::::::: " + JSON.stringify(basicInfo)
    //     );
    //     const exurl = basicInfo?.misc?.import_global_contacts ?? "";
    //     setexpUrl(exurl);
    //     // setuseCases(basicInfo?.misc?.campaign_registration?.usecases ?? []);
    //     // setsubUseCases(basicInfo?.misc?.campaign_registration?.sub_usecases ?? []);


    // }
    async function handleDownload() {
        try {
            let apiResponse = await downloadContacts(JSON.parse(sessionStorage.getItem("admin_session")).siteid, TabIDConstant.IMP_GLOBAL_CONTACTS_SUBLINK);
            let filename = "Import Contacts.csv";
            if (apiResponse.status == 200) {
                const fileUrl = URL.createObjectURL(await apiResponse.blob());
                const a = document.createElement("a");
                a.href = fileUrl;
                a.download = filename;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            } else {
                // setInternalError(true);
            }
        } catch (error) {
            console.log("Error ::::::::: " + error);
        }
    }

    async function redirectToWSContactAPI(e) {
        try {
            e.preventDefault();
            let apiResponse = await getWSContactsRedirectHtml(1, TabIDConstant.IMP_GLOBAL_CONTACTS_SUBLINK);
            if (apiResponse.status == 200) {
                const html = await apiResponse.text();
                // Open blank popup and inject HTML
                const popup = window.open("", "_blank", "toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=600");
                popup.document.open();
                popup.document.write(html);
                popup.document.close();
            }
        } catch (error) {

        }
    }
    return (
        <>
            <div>
                <div className='px-3 d-flex flex-column align-items-center justify-content-center'>
                    <h5 className='pt-4'>{t('downloadCSVtmp')}</h5>
                    <MDBBtn className="w-50 mt-3" onClick={(e) => {
                        e.preventDefault();
                        handleDownload();
                    }}> <MDBIcon fas icon="arrow-down" className="me-2" />Download Import Global Contacts Template</MDBBtn>


                    <MDBTypography className="cursor-pointer mt-3" onClick={toggleOpen3} >
                        <MDBTypography tag='u'>Instructions to fill the Import Global Contacts Template</MDBTypography>
                    </MDBTypography>
                    <div>

                        <p className="text-danger mt-3">   <b className="text-danger"> Note:</b> Spread Sheet can contain a maximum of 10000 contacts to be uploaded.</p>

                    </div>



                    <p><a onClick={redirectToWSContactAPI} style={{ textDecoration: "underline" }}>Click here </a>to import global contacts.</p>


                    <MDBModal tabIndex='-1' open={centredModal2} setShow={setCentredModal2}>
                        <MDBModalDialog centered>
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle>{t("instructions")}</MDBModalTitle>
                                    <MDBBtn className='btn-close' color='none' onClick={toggleOpen3}></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <ul>
                                        <li>The maximum number of contacts that can be imported to the account is 10000.</li>
                                        <li>Entering First Name or Last Name or Email or Alternate Email is mandatory.</li>
                                        <li>This process may take few minutes to import contacts and display in Personal and Global Contacts section in {streamsProductName}.</li>
                                    </ul>
                                </MDBModalBody>
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>



                </div>

            </div >

        </>
    )
}

export default ImportGlobalContacts
